<template>
<!--  <row justify="center" align="center" class="fill-height">

  </row>-->
  <b-container fluid>
  </b-container>
</template>

<script>
// @ is an alias to /src
//import axios from 'axios'
//axios.defaults.withCredentials = true;
//axios.defaults.baseURL = 'http://localhost:8000/'
/*import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
*/
export default {
  //name: "HomeAsiste",
  data() {
    return {
      /*
      url: process.env.VUE_APP_URL,
      title: process.env.VUE_APP_TITLE
      */
    };
  },
  mounted() {
    /*axios.get('/api/user').then(response => {
            this.email = response.data.email
            this.avatar = response.data.avatar
        });*/
    /*
    this.$api.get('/api/user').then(response => {
            this.email = response.data.email
            this.avatar = response.data.avatar
        })*/
  },

  methods: {
    /*login(){
        axios.get('/sanctum/csrf-cookie').then(() => {
            axios.post('/login', {
              email: '',
              password: '',
            }).then(() => {
              //console.log(response)
              this.$router.push({ name: 'Dashboard'})
            })
        });
    },
    loginGoogle(){
      axios.get('/sanctum/csrf-cookie').then(() => {
            window.location = "http://localhost:8000/redirect"
        });
    }*/
  },
  computed: {
    redirect() {
      return this.$store.getters.usuario.redirect;
    },
  },
  watch: {
    redirect(newValue) {
      this.$router.push({ path: newValue });
    },
  },
};
</script>